export function newRequestId(): string {
  try {
    return crypto.randomUUID();
  } catch {
    return "req-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
  }
}
